import { RouteObject } from 'react-router-dom';
import React from 'react';
import { SIGN_UP_ROUTES } from './route.definitions';
import { SignUpPage } from './page';

export const signUpRoutes: RouteObject = {
  path: SIGN_UP_ROUTES.ABSOLUTE_PATH,
  element: <SignUpPage />,
};
